"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMode = getMode;
exports.editing = exports.active = exports.highlighted = exports.inactive = void 0;

var _isNil = _interopRequireDefault(require("lodash/isNil")); // The cell is not in selected region.


var inactive = 0; // The cell is in the selected region but not targeted to be edited.

exports.inactive = inactive;
var highlighted = 1; // The cell is targeted to be edited.

exports.highlighted = highlighted;
var active = 2; // The cell is being edited.

exports.active = active;
var editing = 3;
exports.editing = editing;

function isBetween(x, start, end) {
  return x >= Math.min(start, end) && x < Math.max(start, end);
}

function isSelected(columnIndex, rowIndex, selection) {
  var hasSelection = !(0, _isNil.default)(selection);
  var xMatch = (0, _isNil.default)(columnIndex) || hasSelection && isBetween(columnIndex, selection.left, selection.right);
  var yMatch = (0, _isNil.default)(rowIndex) || hasSelection && isBetween(rowIndex, selection.top, selection.bottom);
  return xMatch && yMatch;
}

function isActive(columnIndex, rowIndex, selection) {
  var hasSelection = !(0, _isNil.default)(selection);
  var xMatch = hasSelection && !(0, _isNil.default)(columnIndex) && selection.activeX === columnIndex;
  var yMatch = hasSelection && !(0, _isNil.default)(rowIndex) && selection.activeY === rowIndex;
  return xMatch && yMatch;
}
/**
 * Get the current edit mode of a cell.
 * @param {number} columnIndex The column index of the cell
 * @param {number} rowIndex The row index of the cell
 * @param {object} selection The selection state of the editor
 * @param {boolean} isEditing If the editor is in edit mode
 */


function getMode(columnIndex, rowIndex, selection, isEditing) {
  if (isActive(columnIndex, rowIndex, selection)) {
    return isEditing ? editing : active;
  }

  if (isSelected(columnIndex, rowIndex, selection)) {
    return highlighted;
  }

  return inactive;
}